import React, { useState, useEffect } from 'react';
import GetIcon from '../../../../utils/Icon';
import { useGetcustomerMutation, useGetCustomerDetailsMutation } from "../../../../store/api/customer_api";
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';

function Tab1({ formdata, setTab1Data, setTab1CustomerData, orderNo, termandcondition, fieldErrors, activityboll, pTerms, price, currency, taxandchanges, project, cost_center }) {
  console.log(orderNo, "orderNo_came");

  const [showActivity, setShowActivity] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [getCustomer, { data: getitem_list_data }] = useGetcustomerMutation();
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [getCustomerDetails] = useGetCustomerDetailsMutation();


  useEffect(() => {
    getCustomer({ search_input: '' });
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const body = { search_input: searchTerm };
      getCustomer(body);
    }
  }, [searchTerm]);

  useEffect(() => {
    const fetchDetails = async () => {
      if (selectedCustomer) {
        try {
          const response = await getCustomerDetails({ customer_name: selectedCustomer });
          if (response?.data) {
            setTab1CustomerData(prev => ({
              ...prev,
              customerDetails: response.data
            }));
          }
        } catch (error) {
          console.error("Failed to fetch customer details:", error);
        }
      }
    };
    fetchDetails();
  }, [selectedCustomer]);

  const customerOptions = getitem_list_data?.result?.customers?.map(customer => ({
    name: customer.name
  })) || [];
  return (

    <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "72vh",
        minHeight: "72vh",
        overflowY: "scroll",

      }}
    >
      <div style={{ maxHeight: "72vh", }}>
        <div className="d-flex gap-2 mb-2" style={{ width: "100%" }}>
          <div className="col">
            <Input
              id="Sales Invoice Id"
              label="Sales Invoice Id"
              value={formdata.sales_invoice_id}
              style={{ height: "30px" }}
              className={fieldErrors.orderNo ? 'error-border' : ''}
              readOnly
            />
          </div>
          <div className="col">
            <Input
              id="date"
              label="Order Date"
              type="date"
              value={formdata.payment_due_date}
              style={{ height: "30px" }}
              className={fieldErrors.date ? 'error-border' : ''}
              readOnly
            />
          </div>
        </div>

        <div className="w-100 mb-3">
          <SelectSearch
            list={customerOptions}
            label="Select Customer"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formdata.customer}
            disabled
            onInputChange={setSearchTerm}
            className={fieldErrors.customer ? 'error-border' : ''}
          />
        </div>


        <div className="col mb-3">
          <Input
            id="Mobile No"
            label="Mobile No"
            value={formdata.mobile_no}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>

        <div className="col mb-3">
          <Input
            id="Delivery Address"
            label="Delivery Address"
            value={formdata.delivery_address}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>



        <div className="col mb-3">
          <Input
            id="due_date"
            label="Payment Due Date"
            value={formdata.due_date}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>
        <CollapsibleSection title="Accounting Dimensions">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={cost_center.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={cost_center.list}
                label="Cost Center"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={cost_center.value}
                onChange={(val) => cost_center.setvalue(val)}
              />
            </div>
          </div>
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={project.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={project.list}
                label="Project"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={project.value}
                onChange={(val) => project.setvalue(val)}
              />
            </div>
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Payment Terms">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={pTerms.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={pTerms.list}
                label="Payment Terms Template"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={pTerms.paymentterm}
                onChange={(val) => pTerms.setpaymentterm(val)}
              />
            </div>
          </div>

        </CollapsibleSection>

        <CollapsibleSection title="Currency and Price List">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={currency.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={currency.list}
                label="Currency"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={currency.value}
                onChange={(val) => currency.setvalue(val)}
              />
            </div>
          </div>

          <div className="col-lg-12 mt-3 mb-3" >
            <div className={price.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={price.list}
                label="Price List"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={price.value}
                onChange={(val) => price.setvalue(val)}
              />
            </div>
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Taxes and Charges">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={taxandchanges.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={taxandchanges.list}
                label="Taxes and Charges"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={taxandchanges.value}
                onChange={(val) => taxandchanges.setvalue(val)}
              />
            </div>
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Terms & Conditions">

          <div className="col-lg-12 mt-1 mb-3" >
            <div className={termandcondition.Error ? `mb-3 errorborder` : `mb-3`}>
              <SelectSearch
                list={termandcondition.list}
                label="Terms and Conditions"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={termandcondition.termsandcondition}
                onChange={(val) => termandcondition.settermsandcondition(val)}
              />
            </div>
          </div>

        </CollapsibleSection>


        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0">
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory doctype="Sales Order" docname={orderNo} activityboll={activityboll} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Tab1;